const strings = {
  title: 'Nova Interação',
}

export default strings
